import React from 'react'
import { useNotify, useRefresh, useRecordContext, Button } from 'react-admin'
import { ENTRYPOINT } from '../config/entrypoint'

const ActionButton = ({ uri, label, fromStatus = null, ...rest }) => {
    const notify = useNotify()
    const refresh = useRefresh()
    const record = useRecordContext()

    const [loading, setLoading] = React.useState(false)

    if (!record) return null
    if (null !== fromStatus && !fromStatus.includes(record.status)) return null

    const handleValidate = async () => {
        setLoading(true)
        try {
            const response = await fetch(`${ENTRYPOINT}${record.id}/${uri}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
                },
            })
            if (!response.ok) throw new Error('Erreur API')
            notify('Action réussie', { type: 'success' })
            refresh()
        } catch (e) {
            notify('Erreur lors de la validation', { type: 'error' })
        } finally {
            setLoading(false)
        }
    }

    return (
        <Button onClick={handleValidate} disabled={loading} style={getButtonStyle(uri)}>
            {loading ? 'En cours...' : label}
        </Button>
    )
}

const getButtonStyle = (uri) => {
    switch (uri) {
        case 'publish':
            return {
                background: '#2196f3',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '8px 24px',
                margin: '8px 8px 8px 0',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(33,150,243,0.15)',
                transition: 'background 0.2s',
            }
        case 'cancel':
            return {
                background: '#f44336',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '8px 24px',
                margin: '8px 8px 8px 0',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(244,67,54,0.15)',
                transition: 'background 0.2s',
            }
        case 'reject':
            return {
                background: '#ff9800',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '8px 24px',
                margin: '8px 8px 8px 0',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(255,152,0,0.15)',
                transition: 'background 0.2s',
            }
        default:
            return {
                background: '#e0e0e0',
                color: '#333',
                border: 'none',
                borderRadius: 6,
                padding: '8px 24px',
                margin: '8px 8px 8px 0',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                transition: 'background 0.2s',
            }
    }
}

export default ActionButton
